import axios from "axios"
export default (fetch) => {
  return {
    // user-机构资质-提交申请
    async submit(body) {
      const {data} = await fetch.post('/arcopen/user/company/submit', {
        co_name: body.co_name,
        uscc: body.uscc,
        description: body.description,
        net_addr: body.net_addr,
        company_addr: body.company_addr,
        license_url: body.license_url,
        application_url: body.application_url,
        contact: body.contact,
        tel: body.tel,
        email: body.email,
        captcha: body.captcha,
        identity_cards_number: body.identity_cards_number,
        safety_questionnaire: body.safety_questionnaire,
        sq_file_name: body.sq_file_name,
      })

      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-机构资质-编辑
    async edit(body) {
      const {data} = await fetch.post('/arcopen/user/company/edit', {
        co_name: body.co_name,
        uscc: body.uscc,
        description: body.description,
        net_addr: body.net_addr,
        company_addr: body.company_addr,
        license_url: body.license_url,
        application_url: body.application_url,
        contact: body.contact,
        tel: body.tel,
        email: body.email,
        captcha: body.captcha,
        identity_cards_number: body.identity_cards_number,
        safety_questionnaire: body.safety_questionnaire,
        sq_file_name: body.sq_file_name,
      })

      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-机构资质-查询
    // 状态 state 0-待审核，1-审核通过，2-审核驳回
    async view() {
      const {data} = await fetch.get('/arcopen/user/company/view')
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-机构营业执照-上传
    async licenseUpload(file) {
      const form = new FormData()
      form.append('file', file)
      const {data} = await fetch.post('/arcopen/user/company/license/upload', form)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    // user-应用-尽调问卷上传
    async questionnaireUpload(file) {
      const form = new FormData()
      form.append('file', file)
      const {data} = await fetch.post('/arcopen/user/company/questionnaire/upload', form)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('上传失败')
      }
    },
    // user-机构入驻申请函-上传
    async applicationUpload(file) {
      const form = new FormData()
      form.append('file', file)
      const {data} = await fetch.post('/arcopen/user/company/application/upload', form)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
  }
}

// 查询企业资质是否可以提交
const whether = async (data) => {
  const {data: res} = await axios.post('/arcopen/user/company/lock', data)
  if (res.code === 0) {
    return res.data
  } else {
    throw new Error(res.message)
  }
}
export { whether }